import { makeObservable, observable, action } from "mobx";

import OpsSyncAnalyticsDashboardAPI from "../../api/dashboards/OpsSyncAnalyticsDashboardAPI";
import { OpsSyncAnalyticsAPIFilters } from "../../models/Dashboard/OpsSyncAnalyticsFilters";
import { OpsSyncAnalyticsData } from "../../models/Dashboard/OpsSyncAnalyticsData";

export class OpsSyncAnalyticsDashboardStore {
  analyticsAPI: OpsSyncAnalyticsDashboardAPI;
  data: OpsSyncAnalyticsData[];
  localSearchTerm: string;
  appliedLocalSearchTerm: string;
  filteredData: OpsSyncAnalyticsData[];

  constructor() {
    this.analyticsAPI = new OpsSyncAnalyticsDashboardAPI();
    this.data = [];
    this.localSearchTerm = "";
    this.appliedLocalSearchTerm = "";
    this.filteredData = [];

    makeObservable(this, {
      data: observable,
      localSearchTerm: observable,
      appliedLocalSearchTerm: observable,
      filteredData: observable,
      getData: action,
      setLocalSearchTerm: action,
      applyLocalSearch: action,
      clearLocalSearch: action,
    });
  }

  getData = async (filters: OpsSyncAnalyticsAPIFilters) => {
    try {
      this.data = await this.analyticsAPI.getData("ops-sync/data", filters);
      this.filteredData = [...this.data];
      // Reapply local search if there's an applied search term
      if (this.appliedLocalSearchTerm) {
        this.applyLocalSearch();
      }
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  setLocalSearchTerm = (searchTerm: string) => {
    this.localSearchTerm = searchTerm;
  };

  applyLocalSearch = () => {
    this.appliedLocalSearchTerm = this.localSearchTerm;

    if (this.appliedLocalSearchTerm.length === 0) {
      this.filteredData = [...this.data];
      return;
    }

    if (this.appliedLocalSearchTerm.length > 1) {
      const searchLower = this.appliedLocalSearchTerm.toLowerCase();

      this.filteredData = this.data.filter((item) => {
        return (
          String(item.order_id).toLowerCase().includes(searchLower) ||
          String(item.product_id).toLowerCase().includes(searchLower) ||
          (item.product_name &&
            item.product_name.toLowerCase().includes(searchLower)) ||
          (item.customer_name &&
            item.customer_name.toLowerCase().includes(searchLower))
        );
      });
    } else {
      this.filteredData = [...this.data];
    }
  };

  clearLocalSearch = () => {
    this.localSearchTerm = "";
    this.appliedLocalSearchTerm = "";
    this.filteredData = [...this.data];
  };
}
